import { FormattedMessage } from "react-intl";

import styled from "styled-components";
import CustomButton from "components/Button";
import { OpenNewTabIcon } from "views/layout/Sidebar/component/ChatSidebar/components/icons/SidebarDropdownSVG";
import links from "core/links";
import { useWindowSize } from "hooks/useWindowSize";

const DurationButton = styled(CustomButton)`
  background-color: #171717;
  color: #fff;
  flex-shrink: 0;
  font-size: 14px;
  line-height: normal;
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  font-family: "inter";
  transition: wdith 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
//  margin: 0 auto; 
  &:hover,
  &:focus,
  &:active {
  padding: 8px 10px;
  width: 99%;
    background-color: #4338ca;
  }

  @media (max-width: 576px) {
    font-size: 12px;
    padding: 5px 12px;
  }
`;

export const RequestModel = () => {
  const { width } = useWindowSize();
  return (
    <div
      className="flex flex-col gap-4 p-[12px] rounded-[6px] bg-[#FFFBEE]"
      style={{ border: "0.5px dashed #D97706" }}
    >
      <div className="flex flex-col gap-[6px] items-start">
        <div className={`font-inter font-semibold text-[#D97706] ${width<=576 ? "text-[12px]": "text-[14px]"}`}>
          <FormattedMessage id="gptmode.request.title" />
        </div>
        <div className={`font-inter font-normal text-[#D97706]  ${width<=576 ? "text-[11px]": "text-[12px]"}`}>
          <FormattedMessage id="gptmodel.request.subtitle" />
        </div>
      </div>
      <a
        href={links.FeatureRequest}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline"
      >
        <DurationButton>
          <span className="font-inter items-center flex gap-3 py-2 px-4 ">
            <FormattedMessage id="gptmodel.request.btn" />
            <span className="leading-[0] flex-shrink-0">
              <OpenNewTabIcon />
            </span>
          </span>
        </DurationButton>
      </a>
    </div>
  );
};
